/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Download_Medical_AriaInputs */

const en_claims_download_medical_aria = /** @type {(inputs: Claims_Download_Medical_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Medical Claim Form`)
};

const fr_claims_download_medical_aria = /** @type {(inputs: Claims_Download_Medical_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger le formulaire de réclamation médicale`)
};

/**
* | output |
* | --- |
* | "Download Medical Claim Form" |
*
* @param {Claims_Download_Medical_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_download_medical_aria = /** @type {((inputs?: Claims_Download_Medical_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Download_Medical_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_download_medical_aria(inputs)
	return fr_claims_download_medical_aria(inputs)
});